import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Button } from 'antd';
import { permissionService } from 'shared/services';
import get from 'lodash/get';

import { Link } from 'react-router-dom';
import Table from 'components/Table';
import { FILTER_TYPE, paginationParam } from 'shared/constant';
import NewFilter from 'components/NewFilter';

import urlUtil from 'shared/utils/UrlUtil';

import text from './BillerList.page.translation';
import allBillersRoute from '../../route';
import { ENUM_STATUS } from '../../constant/AllBillerDefaultVar';
import './BillerList.style.less';

const { checkPermission } = permissionService;

class BillerList extends PureComponent {
  constructor(props) {
    super(props);
    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount() {
    const { match, filterValue } = this.props;
    if (match.params.page) {
      this.updateBillerTable(filterValue);
    } else {
      this.updateBillerTable([]);
    }
  }

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updateBillerTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this._handleChangePage(1);
        } else {
          this.updateBillerTable(filterValue);
        }
      }
    }
  }

  updateBillerTable = filterValue => {
    const { getListBiller, billerFilter, match, history } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';
    const page = get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl = this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...billerFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getListBiller(paginationUrl, paramUrl);
      } else {
        history.push(allBillersRoute.BILLERS);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getListBiller(paginationUrl, paramUrl);
    }
  };

  renderNoColumn = (t, r, index) => {
    let modifyIndex;
    const adjustIndex = index + 1;
    const { billerFilter } = this.props;
    if (billerFilter.page_num === 1) {
      modifyIndex = adjustIndex;
    } else {
      modifyIndex = adjustIndex + (billerFilter.page_num - 1) * 10;
    }
    return modifyIndex;
  };

  renderBillerName = (name, record) => {
    const link = allBillersRoute.BILLERS_DETAIL.replace(':id', record.id);
    return <Link to={link}>{name}</Link>;
  };

  statusTableCase = status => {
    switch (status) {
      case 2:
        return <span className="status-text active">Active</span>;
      case 1:
        return <span className="status-text inactive">InActive</span>;
      default:
        return <span className="status-text hidden">Hidden</span>;
    }
  };

  renderIconBiller = row => <img src={row} alt={row} className="table-icon" />;

  _renderBtnNewBiller = () => (
    <Button
      type="primary"
      block
      className="btn register-vendor-btn"
      htmlType="submit"
    >
      <Link to={allBillersRoute.BILLERS_CREATE}>Add New Billers</Link>
    </Button>
  );

  _tableColumns = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return [
      {
        title: formatMessage(text.no),
        key: 'index',
        render: this.renderNoColumn,
      },
      {
        title: formatMessage(text.billerName),
        key: 'name',
        dataIndex: 'name',
        render: this.renderBillerName,
      },
      {
        title: formatMessage(text.billerId),
        dataIndex: 'public_id',
        key: 'public_id',
      },
      {
        title: formatMessage(text.billerIcon),
        align: 'center',
        key: 'icon_abs_url',
        dataIndex: 'icon_abs_url',
        render: this.renderIconBiller,
      },
      {
        title: formatMessage(text.service),
        dataIndex: 'service',
        key: 'service',
        render: item => (item ? item.name : 'NULL'),
      },
      {
        title: formatMessage(text.playgroundStatus),
        dataIndex: 'pground_status',
        key: 'pground_status',
        render: val => this.statusTableCase(val),
      },
      {
        title: formatMessage(text.skywalkerStatus),
        dataIndex: 'skyw_status',
        key: 'skyw_status',
        render: val => this.statusTableCase(val),
      },
    ];
  };

  _getRowId = row => row.id;

  _renderBreadCrumb = () => (
    <div className="breadcrumb-wrapper">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Billers</Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = billerFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(billerFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(billerFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(billerFilter.page_num)}`;

    return result;
  };

  _handleChangePage = page => {
    urlUtil.changePageParams(allBillersRoute.BILLERS, page, this.props.history);
  };

  render() {
    const {
      intl: { formatMessage },
      billerFilter,
      loading,
      listBiller,
    } = this.props;
    const totalItem = billerFilter.page_size * billerFilter.page_count;

    const options = [
      {
        label: formatMessage(text.billerName),
        value: 'name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Biller Public Id',
        value: 'public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Service Public Id',
        value: 'service_public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Service Name',
        value: 'service_name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.playgroundStatus),
        value: 'pground_status',
        type: FILTER_TYPE.RADIO,
        options: ENUM_STATUS,
      },
      {
        label: formatMessage(text.skywalkerStatus),
        value: 'skyw_status',
        type: FILTER_TYPE.RADIO,
        options: ENUM_STATUS,
      },
      {
        label: 'Archived',
        value: 'is_archived',
        type: FILTER_TYPE.BOOL,
      },
    ];

    return (
      <div className="main-content biller-page">
        {this._renderBreadCrumb()}

        <div className="white-box-wrapper">
          <span className="title mbottom30">{formatMessage(text.billers)}</span>

          {checkPermission('Biller:create', true) && this._renderBtnNewBiller()}
          <NewFilter options={options} />
          <div className="table-wrapper">
            <Table
              bordered
              rowID={this._getRowId}
              rowKey={this._getRowId}
              columns={this._tableColumns()}
              dataSource={listBiller}
              pagination="true"
              rowClass="striped-table"
              loadingValue={loading}
              totalItem={totalItem}
              currentPage={billerFilter.page_num}
              changePage={this._handleChangePage}
              crollX={1930}
            />
          </div>
        </div>
      </div>
    );
  }
}

BillerList.propTypes = {
  intl: PropTypes.object.isRequired,
  getListBiller: PropTypes.func.isRequired,
  listBiller: PropTypes.array.isRequired,
  billerFilter: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  resetFilter: PropTypes.func,
  filterValue: PropTypes.array,
  history: PropTypes.object,
  match: PropTypes.object,
  formControlShow: PropTypes.bool,
};

export default BillerList;
